import { Stack, Text } from '@mantine/core';

interface TextListProps {
    items?: string[];
}

export const TextList = ({ items }: TextListProps) => {
    if (!items?.length) {
        return (
            <Text
                size='sm'
                c='dimmed'
            >
                Нет данных
            </Text>
        );
    }

    return (
        <Stack gap={2}>
            {items.map((item) => (
                <Text
                    key={item}
                    size='sm'
                >
                    {item}
                </Text>
            ))}
        </Stack>
    );
};
